
import { defineComponent, PropType } from "vue";
import CiRouterLink from "@router/router-link.vue";

interface BreadcrumbItem {
  title: string;
  link?: string;
}

export default defineComponent({
  components: {
    "ci-router-link": CiRouterLink,
  },
  props: {
    items: {
      type: Array as PropType<BreadcrumbItem[]>,
      required: true,
    },
  },
});
